export default () => {

  const mainContent = document.querySelector('.section-wysiwyg'),
      iframes = mainContent?.querySelectorAll('iframe');

  if (!mainContent) {
    return;
  }

  iframes?.forEach(iframe => {
    const iframeContainer = document.createElement('div'),
          parent = iframe.parentNode;

    iframeContainer.classList.add('iframe-container');
    parent.replaceChild(iframeContainer, iframe);

    iframeContainer.appendChild(iframe);
  });

}